import PointsCardVue from '@/views/sa/points-card/points-card.vue';

const basePath = '/sa/points-card';
const role = 'sa'; // 角色身份

export const SA_POINTS_CARD_INDEX = 'sa-points-card-index';
export const SA_MISSIONS_LIST = 'sa-missions-list';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: PointsCardVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_POINTS_CARD_INDEX,
      component: () => import(
        `@/views/${role}/points-card/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/missions-list`,
      name: SA_MISSIONS_LIST,
      props: true,
      component: () => import(
        `@/views/${role}/points-card/missions-list.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
